define('widgets/hint',[
	'jquery',
	'lib/jquery-ui/widget'
], function ($) {

	return $.widget('muse.hint', {

		options: {
		},

		_create: function () {

			this.$input = this.element.find('input, textarea');
			this.$hint = this.element.find('.hint');

			this.element.addClass('hint-wrap');

			this._on(this.$input, {
				'mouseover': $.proxy(this, 'onMouseOver'),
				'mouseout': $.proxy(this, 'onMouseOut')
			});

			return this._super();

		},

		onMouseOver: function () {

			if (this.$input.val() === '')
				this.$hint.addClass('show');

		},

		onMouseOut: function () {

			this.$hint.removeClass('show');

		}

	});

});
